import api from 'api';

const BASE = '/admin_dashboard/permissions';

export const listPermissionKeys = () => api.get(`${BASE}/keys`);

export const listPermissionUsers = () => api.get(`${BASE}/users`);

export const addPermissionUser = (userId) => api.post(`${BASE}/users`, {
  user_id: userId,
});

export const removePermissionUser = (userId) => api.delete(`${BASE}/users/${userId}`);

export const setUserPermission = (userId, permissionKey, granted) => api.put(
  `${BASE}/users/${userId}`,
  {
    permission_key: permissionKey,
    granted,
  },
);
